import Vue from 'vue';
import Router from 'vue-router';

import Detail016001 from '../components/016001/Detail';
import DetailTBM016001 from '../components/016001/DetailTBM';
import Step5_016001 from '../components/016001/Step5';
import Detail016002 from '../components/016002/Detail';
import DetailTBM016002 from '../components/016002/DetailTBM';
import Step5_016002 from '../components/016002/Step5';
import List from '../components/List';
import Login from '../components/Login';
import Main from '../components/Main';
import SlideNATM from '../components/SlideNATM';
import SlideTBM from '../components/SlideTBM';
import Step1 from '../components/Step1';
import Step2 from '../components/Step2';
import Step3 from '../components/Step3';
import Step3TBM from '../components/Step3TBM';
import Step4 from '../components/Step4';
import ThreeDimensional from '../components/ThreeDimensional';
//import PhotoEditor from '../components/common/PhotoEditor';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                bodyClass: 'login'
            }
        },
        {
            path: '/',
            name: 'Main',
            alias: '/main',
            component: Main,
            meta: {
                bodyClass: 'main'
            }
        },
        {
            path: '/list',
            name: 'List',
            component: List,
            meta: {
                bodyClass: 'list'
            }
        },
        {
            path: '/list/:target',
            name: 'List',
            component: List,
            meta: {
                bodyClass: 'list'
            }
        },
        {
            path: '/slideNATM',
            name: 'SlideNATM',
            component: SlideNATM,
            meta: {
                bodyClass: 'slideNATM'
            }
        },
        {
            path: '/slideTBM',
            name: 'SlideTBM',
            component: SlideTBM,
            meta: {
                bodyClass: 'slideTBM'
            }
        },
        {
            path: '/detail/016001/:id',
            name: 'Detail',
            component: Detail016001,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/detail/016002/:id',
            name: 'Detail',
            component: Detail016002,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/detailTBM/016001/:id',
            name: 'DetailTBM',
            component: DetailTBM016001,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/detailTBM/016002/:id',
            name: 'DetailTBM',
            component: DetailTBM016002,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/step1/:id?',
            name: 'Step1',
            component: Step1,
            meta: {
                bodyClass: 'step1'
            }
        },
        {
            path: '/step2/:id?',
            name: 'Step2',
            component: Step2,
            meta: {
                bodyClass: 'step2'
            }
        },
        {
            path: '/step3/:id?',
            name: 'Step3',
            component: Step3,
            meta: {
                bodyClass: 'step3'
            }
        },
        {
            path: '/step4/:id?',
            name: 'Step4',
            component: Step4,
            meta: {
                bodyClass: 'step4'
            }
        },
        {
            path: '/step3TBM/:id?',
            name: 'Step3TBM',
            component: Step3TBM,
            meta: {
                bodyClass: 'step3TBM'
            }
        },
        {
            path: '/ThreeDimensional',
            name: 'ThreeDimensional',
            component: ThreeDimensional,
            meta: {
                bodyClass: 'threeDimensional'
            }
        },
        {
            path: '/step5/016001/:id?',
            name: 'Step5_1',
            component: Step5_016001,
            meta: {
                bodyClass: 'step5'
            }
        },
        {
            path: '/step5/016002/:id?',
            name: 'Step5_2',
            component: Step5_016002,
            meta: {
                bodyClass: 'step5'
            }
        }
    ]
});

export default router;
